import axios, { AxiosPromise } from 'axios';

import { IUnitOfMeasureType } from '../../../@types/model/masterData/unitOfMeasureType/unitOfMeasureType';

export default class UnitOfMeasureTypeHttpService {
    public static getUnitOfMeasureTypeData() : AxiosPromise<Array<IUnitOfMeasureType>> {
        return axios.get(`${API_URL}/v1/UnitOfMeasureType/GetAllWeb`);
    }

    public static addOrUpdateUnitOfMeasureType(data : IUnitOfMeasureType) : AxiosPromise<IUnitOfMeasureType> {
        return axios.post(`${API_URL}/v1/UnitOfMeasureType/PostUnitOfMeasureType`, data);
    }

    public static deleteUnitOfMeasureType(unitOfMeasureTypeId : number) : AxiosPromise<IUnitOfMeasureType> {
        return axios.delete(`${API_URL}/v1/UnitOfMeasureType/Delete`, {
            params : { unitOfMeasureTypeId },
        });
    }
}
